import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import React, { useEffect, useMemo, useRef, useState } from "react";

import AddNewPreset from "./AddNewPreset/AddNewPreset";
import UpdateInventoryButton from "./AddNewPreset/UpdateInventoryButton";
import ResetStatusModals from "./AddNewPreset/ResetStatusModals";
import {
  storeActions,
  shopifyActions,
  systemActions,
} from "../../../redux/actions";
import Topbar from "../../../shared/components/topbar/Topbar";
import Button from "../../../shared/components/Buttons/Button";
import {
  getDefaultFields,
  getMappedShopifyFields,
  getShopifyPresetsColumnHeaders,
  isOneMinuteOld,
  isSpinnerEnabled,
} from "../../../shared/utility";
import SearchField from "../../../shared/components/searchField/SearchField";
import SimpleCheckbox from "../../../shared/components/checkBox/SimpleCheckbox";
import ShopifyPresetsMappingModal from "./AddNewPreset/ShopifyPresetsMappingModal";
import DataTableComponent from "../../../shared/components/table/ReactDataTableComponent";
import {
  EMPTY_STRING,
  shopifyConstants,
  buttonNameConstants,
  defaultGlobalShopifyPresetObject,
  LOCK_TYPE,
  TABLE_IDS,
  storeConstants,
  BG_JOB_STATUS,
  SPINNER_MESSAGES,
} from "../../../constants";
import {
  AddIcon,
  CrossIcon,
  SearchIcon,
  BlueBoxIcon,
  ShowIcon,
} from "../../../assets/icons/iconsProvider";

//------- Default gridState
const defaultGridState = {
  pageSize: 50,
  pageIndex: 0,
  sortBy: [],
};

const ShopifyPresets = (props) => {
  //------- Destructuring props
  const {
    shopify,
    spinnerArray,
    currentStore,
    shopifySettings,
    deleteShopifyPreset,
    updateGlobalShopifyPreset,
    dfStartOrchestrator,
    getStoreMiscData,
    storeMiscData,
    dfCancelOrchestrator,
    draggableNotification,
    getUpdatedCurrentStoreDetails,
    lastBackgroundJobCreatedAt,
  } = props;
  const { global } = shopifySettings;

  //------- useRef
  const numOfRenders = useRef(0);
  const isResetButtonDisabled =
    Array.isArray(storeMiscData) &&
    storeMiscData.some(
      (row) =>
        row.miscData?.status !== BG_JOB_STATUS.COMPLETED &&
        row.miscData?.status !== BG_JOB_STATUS.FAILED &&
        row.miscData?.status !== BG_JOB_STATUS.TERMINATED
    );
  //------- useStates
  const [columns, setColumns] = useState([]);
  const [editPreset, setEditPreset] = useState({});
  const [searchText, setSearchText] = useState("");
  const [initialMapping, setInitialMapping] = useState({});
  const [updatedRowsData, setupdatedRowsData] = useState([]);
  const [gridState, setGridState] = useState(defaultGridState);
  const [defaultSortFieldId, setDefaultSortFieldId] = useState();
  const [isShopifyMappingModal, setIsShopifyMappingModal] = useState(false);
  const [isAddShopifyPresetModal, setIsAddShopifyPresetModal] = useState(false);
  const [
    isUpdatingInventoryPresetsToDefault,
    setIsUpdatingInventoryPresetsToDefault,
  ] = useState(isResetButtonDisabled);
  //] = useState(currentStore.isUpdatingInventoryPresetsToDefault || false);
  const [showResetStatusModal, setShowResetStatusModal] = useState(false);

  const disableCancelResetConfirmationButtons = isSpinnerEnabled(
    spinnerArray,
    storeConstants.CANCEL_ORCHESTRATOR
  );

  //------- toggleAddShopifyPresetModal
  const toggleAddShopifyPresetModal = () => {
    setIsAddShopifyPresetModal((prev) => !prev);
  };

  //------- toggleShopifyMappingModal
  const toggleShopifyMappingModal = () => {
    setIsShopifyMappingModal((prev) => !prev);
  };

  //------- toggleResetStatusModal
  const toggleResetStatusModal = () => {
    setShowResetStatusModal((prev) => !prev);
  };

  //-------Clear Seach Text
  const clearSearchText = () => {
    setSearchText((prev) => EMPTY_STRING);
  };

  //-------Handle Add Click
  const handleAddClick = () => {
    //------- Logic for adding a new Shopify preset
    setEditPreset({});
    toggleAddShopifyPresetModal();
  };

  //-------Handle searchfield change
  const handleFilterData = (e) => {
    const filterList = updatedRowsData.filter((row) => {
      return (
        String(row.categoryName + row.maxPriceRange + row.minPriceRange)
          .toLowerCase()
          .includes(String(searchText).toLowerCase()) &&
        searchText !== EMPTY_STRING
      );
    });
    //------- reset the pagination
    numOfRenders.current++;
    return filterList;
  };

  //-------Table Sort
  const onTableSort = (column, sortDirection) => {
    setColumns(
      columns.map((col) => {
        if (col.id === column.id) {
          return {
            ...col,
            sortDirection,
          };
        } else {
          return {
            ...col,
            sortDirection: null,
          };
        }
      })
    );

    setDefaultSortFieldId(column.id);
  };

  //-------Update Grid State
  const updateGridState = (newGridState) => {
    setGridState(newGridState);
  };

  //------ handle delete click
  const handleDeleteClick = (id) => {
    deleteShopifyPreset(currentStore?.id, [id]);
  };

  //------ hadleEditClick
  const handleEditClick = (row) => {
    setEditPreset(row);
    toggleAddShopifyPresetModal();
  };

  // Combined handler for saving mapping and checkbox changes
  const handleUpdateGlobalShopifyPreset = (
    updatedFields,
    callback = () => {}
  ) => {
    let globalData = global?.id
      ? global
      : defaultGlobalShopifyPresetObject(currentStore);
    globalData = {
      ...globalData,
      ...updatedFields,
    };

    updateGlobalShopifyPreset(currentStore?.id, globalData, callback);
  };

  const handleSaveMappning = (fieldsMapping) => {
    handleUpdateGlobalShopifyPreset(
      { shopifyMapping: getMappedShopifyFields(fieldsMapping) },
      toggleShopifyMappingModal
    );
  };

  //-------Handle Checkbox Change
  const handleCheckboxChange = (name, checked) => {
    handleUpdateGlobalShopifyPreset({ [name]: checked });
  };
  //-------useEffects
  useEffect(() => {
    if (currentStore?.id) {
      setColumns(
        getShopifyPresetsColumnHeaders(handleDeleteClick, handleEditClick)
      );
      setIsUpdatingInventoryPresetsToDefault(isResetButtonDisabled);
    }
    // eslint-disable-next-line
  }, [currentStore?.id, isResetButtonDisabled, storeMiscData]);
  useEffect(() => {
    if (currentStore?.id) {
      getStoreMiscData(
        currentStore.id,
        storeConstants.BG_JOB_RESET_INVENTORY_WITH_SHOPIFY
      );
      getUpdatedCurrentStoreDetails(currentStore.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setupdatedRowsData([
      ...(shopifySettings?.category || []),
      ...(shopifySettings?.subcategory || []),
      ...(shopifySettings?.productType || []),
      ...(shopifySettings?.product || []),
    ]);
  }, [shopifySettings]);

  useEffect(() => {
    if (global?.id) {
      setInitialMapping(getDefaultFields(global));
    }
  }, [global]);

  return (
    <>
      <Topbar title="Shopify Presets Settings"></Topbar>
      <Row className="m-0 w-100">
        <Col md={12} className="tradeIns-heading">
          Custom Shopify Configurations
        </Col>
        <Col md={8} className="p-0">
          <Row className="m-0 h-100  user-screen-wrapper w-100 min-vh-100 ">
            <Row className="m-0  p-0 w-100 user-screen-wrapper">
              <Col md={9} className="">
                <SearchField
                  onChange={(e) => setSearchText(e.target.value)}
                  IconImage={SearchIcon}
                  label="Search"
                  placeHolder="Type or Scan"
                  value={searchText}
                  CrossIcon={searchText ? CrossIcon : ""}
                  clearSearchText={clearSearchText}
                  BlueBoxIcon={BlueBoxIcon}
                />
              </Col>
              <Col
                md={3}
                className="d-flex justify-content-end align-items-end gap-3"
              >
                <Button
                  label={buttonNameConstants.ADD}
                  IconImage={AddIcon}
                  handleClick={handleAddClick}
                  className="w-100"
                />
              </Col>
            </Row>
            <Row className="m-0 p-0  w-100 h-100 user-screen-wrapper  pt-3">
              <DataTableComponent
                tableId={TABLE_IDS.SETTINGS_SHOPIFY_PRESETS}
                className="tradeIn-table-height"
                key={numOfRenders.current}
                columns={columns}
                data={searchText ? handleFilterData() : updatedRowsData}
                onSort={onTableSort}
                defaultSortFieldId={defaultSortFieldId}
                gridState={gridState}
                setGridState={updateGridState}
                total={
                  searchText
                    ? handleFilterData()?.length
                    : updatedRowsData?.length
                }
              />
            </Row>
          </Row>
        </Col>
        <Col md={4}>
          <div className="d-flex justify-content-center align-items-center w-100 shopify-preset-reset gap-2">
            <UpdateInventoryButton
              currentStore={currentStore}
              isUpdatingInventoryPresetsToDefault={
                isUpdatingInventoryPresetsToDefault
              }
              setIsUpdatingInventoryPresetsToDefault={
                setIsUpdatingInventoryPresetsToDefault
              }
              dfStartOrchestrator={dfStartOrchestrator}
              lastBackgroundJobCreatedAt={lastBackgroundJobCreatedAt}
              storeMiscData={storeMiscData}
              draggableNotification={draggableNotification}
              toggleResetStatusModal={toggleResetStatusModal}
            />
          </div>
          <Row className="global-trade-div">
            <p className="tradeIns-heading p-0">
              Global Shopify Configurations
            </p>
            <Col md={12} className="w-100 p-0 d-flex my-2">
              <SimpleCheckbox
                name={shopifyConstants.LINK_TO_SHOPIFY}
                label={buttonNameConstants.LINK_TO_SHOPIFY}
                onChange={handleCheckboxChange}
                isDisabled={isSpinnerEnabled(
                  spinnerArray,
                  shopifyConstants.UPDATE_GLOBAL_SHOPIFY_PRESET
                )}
                checked={global?.[shopifyConstants.LINK_TO_SHOPIFY]}
              />
            </Col>
            {/* <Col md={12} className="w-100 p-0 d-flex my-2">
              <SimpleCheckbox
                name={shopifyConstants.IS_ONLINE_UNIT_SELL_PRICE}
                label={buttonNameConstants.DIFFERENT_ONLINE_PRICE}
                onChange={handleCheckboxChange}
                isDisabled={isSpinnerEnabled(
                  spinnerArray,
                  shopifyConstants.UPDATE_GLOBAL_SHOPIFY_PRESET
                )}
                checked={global?.[shopifyConstants.IS_ONLINE_UNIT_SELL_PRICE]}
              />
            </Col> */}
            <Col md={12} className="w-100 p-0 d-flex my-2">
              <SimpleCheckbox
                name={shopifyConstants.SEPERATE_QUANTITY}
                label={buttonNameConstants.SEPARATE_QUANTITY}
                onChange={handleCheckboxChange}
                isDisabled={isSpinnerEnabled(
                  spinnerArray,
                  shopifyConstants.UPDATE_GLOBAL_SHOPIFY_PRESET
                )}
                checked={global?.[shopifyConstants.SEPERATE_QUANTITY]}
              />
            </Col>
            <Col
              md={12}
              className="d-flex mt-2 p-0 justify-content-end align-items-center gap-3"
            >
              <Button
                type="submit"
                label={buttonNameConstants.EDIT_FIELD_MAPPING}
                handleClick={() => {
                  toggleShopifyMappingModal();
                }}
                isDisabled={isSpinnerEnabled(
                  spinnerArray,
                  shopifyConstants.UPDATE_GLOBAL_SHOPIFY_PRESET
                )}
                className="min-width-btn-trads"
              ></Button>
            </Col>
          </Row>
        </Col>
      </Row>
      {isAddShopifyPresetModal && (
        <AddNewPreset
          editPreset={editPreset}
          initialMappings={initialMapping}
          isAddShopifyPresetModal={isAddShopifyPresetModal}
          toggleAddShopifyPresetModal={toggleAddShopifyPresetModal}
        />
      )}
      {isShopifyMappingModal && (
        <ShopifyPresetsMappingModal
          initialMappings={initialMapping}
          handleSaveClick={handleSaveMappning}
          isShopifyMappingModal={isShopifyMappingModal}
          toggleShopifyMappingModal={toggleShopifyMappingModal}
        />
      )}
      <ResetStatusModals
        currentStore={currentStore}
        showViewStatusModal={showResetStatusModal}
        toggleViewStatusModal={toggleResetStatusModal}
        getStoreMiscData={getStoreMiscData}
        storeMiscData={storeMiscData}
        dfCancelOrchestrator={dfCancelOrchestrator}
        disableCancelResetConfirmationButtons={
          disableCancelResetConfirmationButtons
        }
      />
    </>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  shopify: state.shopify,
  spinnerArray: state.system.spinnerArray,
  currentStore: state.store.currentStore,
  shopifySettings: state.shopify.shopifySettings,
  lastBackgroundJobCreatedAt: state.store.lastBackgroundJobCreatedAt,
  storeMiscData: state.store.storeMiscData,
  draggableNotification: state.system.draggableNotification,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  deleteShopifyPreset: (storeId, data) =>
    dispatch(shopifyActions.deleteShopifyPreset(storeId, data)),
  updateGlobalShopifyPreset: (storeId, data, toggleShopifyMappingModal) =>
    dispatch(
      shopifyActions.updateGlobalShopifyPreset(
        storeId,
        data,
        toggleShopifyMappingModal
      )
    ),
  getUpdatedCurrentStoreDetails: (storeId, shouldUpdateStore = true) =>
    dispatch(
      storeActions.getUpdatedCurrentStoreDetails(storeId, shouldUpdateStore)
    ),
  dfStartOrchestrator: (data) =>
    dispatch(systemActions.dfStartOrchestrator(data)),
  getStoreMiscData: (storeId, type) =>
    dispatch(storeActions.getStoreMiscData(storeId, type)),
  dfCancelOrchestrator: (data) =>
    dispatch(systemActions.dfCancelOrchestrator(data)),
});

//-------Export ShopifyPresets Component
export default connect(mapStateToProps, mapDispatchToProps)(ShopifyPresets);
